import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { setFieldError, removeFieldError } from 'apps/auth/actions/formAction';
import { Row } from 'apps/auth/components/common/Layout/Row';

import InputPassword from './InputPassword';
import media from '../../theme/media';

const ConditionsList = styled.ul`
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;

    ${media.desktop1920} {
        font-size: 17px;
        line-height: 24px;
    }
`;
const ConditionsListItem = styled.li`
    color: ${(props) => (props.current ? props.theme.purple_100 : props.theme.grey_72_lc)};
    padding-left: 16px;
    position: relative;

    &:before {
        content: '•';
        left: 0;
        position: absolute;
        top: 0;
    }
`;

const InputsConfirmPassword = (props) => {
    const PASSWORD_MIN_LENGTH = 8;

    const hasDigit = (password) => password && /\d/.test(password);
    const hasLetter = (password) => password && /[a-z]/i.test(password);
    const hasMinLength = (password) => password && password.length >= PASSWORD_MIN_LENGTH;
    const isAllValid = (password) => hasDigit(password) && hasLetter(password) && hasMinLength(password);
    const arePasswordsEqual = (password1, password2) => password1 && password1 === password2;

    const handlePasswordChange = (value) => {
        if (props.confirmPassword.value) {
            // We should not use arePasswordsEqual() here,
            // because in this case we don't care about password (the first field) validity.
            // We only care about the passwords equality without any other checks.
            if (value !== props.confirmPassword.value) {
                props.setFieldError(props.formName, 'confirmPassword', props.changePasswordSameCheck);
                props.setIsSubmitDisabled?.(true);
            } else {
                props.removeFieldError(props.formName, 'confirmPassword');
                if (isAllValid(props.confirmPassword.value)) {
                    props.setIsSubmitDisabled?.(false);
                }
            }
        }
    };

    const handlePasswordConfirmChange = (value) => {
        if (arePasswordsEqual(props.password.value, value)) {
            if (isAllValid(props.password.value)) {
                props.setIsSubmitDisabled?.(false);
            }
        } else {
            props.setIsSubmitDisabled?.(true);
        }
    };

    const handlePasswordConfirmBlur = (value, name) => {
        if (value) {
            if (!arePasswordsEqual(props.password.value, value)) {
                props.setFieldError(props.formName, name, props.changePasswordSameCheck);
            }
        }
    };

    return (
        <>
            <Row indent="24px">
                <InputPassword formName={props.formName} field={props.password} onChangeHandler={handlePasswordChange} />
            </Row>
            <ConditionsList>
                <ConditionsListItem current={hasDigit(props.password.value)}>{props.changePasswordDigits}</ConditionsListItem>
                <ConditionsListItem current={hasLetter(props.password.value)}>{props.changePasswordLetters}</ConditionsListItem>
                <ConditionsListItem current={hasMinLength(props.password.value)}>{props.changePasswordMinLength}</ConditionsListItem>
            </ConditionsList>
            <Row indent="24px">
                <InputPassword
                    formName={props.formName}
                    field={props.confirmPassword}
                    onChangeHandler={handlePasswordConfirmChange}
                    onBlurHandler={handlePasswordConfirmBlur}
                />
            </Row>
            <ConditionsList>
                <ConditionsListItem current={arePasswordsEqual(props.password.value, props.confirmPassword.value)}>
                    {props.changePasswordSameCheck}
                </ConditionsListItem>
            </ConditionsList>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        changePasswordMinLength: state.messages.pageMessages.changePasswordMinLength,
        changePasswordLetters: state.messages.pageMessages.changePasswordLetters,
        changePasswordDigits: state.messages.pageMessages.changePasswordDigits,
        changePasswordSameCheck: state.messages.pageMessages.changePasswordSameCheck,
    };
};
export default connect(mapStateToProps, { setFieldError, removeFieldError })(InputsConfirmPassword);
